import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

export class StatsCard extends Component {
  render() {
    const clickable = typeof this.props.onClick === "function";
    const alarm = this.props.alarm;
    return (
      <div
        className="card card-stats"
        onClick={this.props.onClick}
        onKeyDown={event => {
          if (!clickable || (event.key !== "Enter" && event.key !== " "))
            return;
          event.preventDefault();
          this.props.onClick();
        }}
        role={clickable ? "link" : undefined}
        tabIndex={clickable ? 0 : undefined}
        title={this.props.title}
        style={clickable ? { cursor: "pointer" } : undefined}
      >
        <div className="content">
          <Row>
            <Col xs={2}>
              <div className="icon-big text-center icon-warning">
                {this.props.bigIcon}
              </div>
            </Col>
            <Col xs={10}>
              <div className="numbers ">
                <p>{this.props.statsText}</p>
                {this.props.statsValue.map((value, key) => {
                  return <div key={key}>{value}</div>;
                })}
              </div>
            </Col>
          </Row>
          {alarm && (
            <div
              role="link"
              tabIndex={0}
              onClick={event => {
                event.stopPropagation();
                if (this.props.onAlarmClick) this.props.onAlarmClick();
              }}
              onKeyDown={event => {
                if (event.key !== "Enter" && event.key !== " ") return;
                event.preventDefault();
                event.stopPropagation();
                if (this.props.onAlarmClick) this.props.onAlarmClick();
              }}
              style={{
                marginTop: 12,
                padding: "9px 10px",
                borderLeft: `4px solid ${alarm.color}`,
                backgroundColor: `${alarm.color}12`,
                cursor: "pointer",
                textAlign: "left"
              }}
              title="Otwórz alarmy tego urządzenia"
            >
              <div style={{ color: alarm.color, fontWeight: "bold" }}>
                {alarm.label}
                {alarm.additionalCount > 0
                  ? ` (+${alarm.additionalCount})`
                  : ""}
              </div>
              <div
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }}
              >
                {alarm.message}
              </div>
              <small>{alarm.time}</small>
            </div>
          )}
          <div className="footer">
            <hr />
            <div className="stats">
              {this.props.statsIcon} {this.props.statsIconText}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StatsCard;



// WEBPACK FOOTER //
// ./src/components/StatsCard/StatsCard.jsx